import { render, staticRenderFns } from "./DetailContractManager.vue?vue&type=template&id=7704c690&scoped=true&"
import script from "./DetailContractManager.vue?vue&type=script&lang=js&"
export * from "./DetailContractManager.vue?vue&type=script&lang=js&"
import style0 from "./DetailContractManager.vue?vue&type=style&index=0&id=7704c690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7704c690",
  null
  
)

export default component.exports